var map = {
	"./category-active.png": "HwW9",
	"./commondisease-active.png": "/2DK",
	"./dorm-active.png": "ePod",
	"./expellinginsects-active.png": "5arC",
	"./home-active.png": "X4/I",
	"./order-active.png": "Go43",
	"./pet-active.png": "i8o8",
	"./product-brand-active.png": "I1r0",
	"./product-list-active.png": "xvOR",
	"./role-active.png": "CdVW",
	"./sms-new-active.png": "r0Ur",
	"./staff-active.png": "bdtf",
	"./store-active.png": "ICOI",
	"./sysShop-active.png": "S3Pu",
	"./ums-admin-active.png": "6rXd",
	"./vaccine-active.png": "Z/Pu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YzOD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu ^\.\/.*\-active\.png$
// module id = YzOD
// module chunks = 26